<template>
  <div v-if="initialized">
    <v-row>
      <v-col>
        <StoryCityTextInput 
          v-model="firstName"
          :placeholder="$t('admin.users.firstName')"
        />
      </v-col>
      <v-col>
        <StoryCityTextInput 
          v-model="lastName"
          :placeholder="$t('admin.users.lastName')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <StoryCityTextInput 
          v-model="penName"
          :placeholder="$t('admin.users.penName')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p>
          {{ $t('becomeACreator.penNameDescriptionPart1')}}
        </p>
        <p>
          {{ $t('becomeACreator.penNameDescriptionPart2')}}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox v-model="newsletter" :label="$t('becomeACreator.agreedToNewsletter')" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ApolloMutation :mutation="UPDATE_USER_PROFILE"
          @done="proceed"
        >
          <template v-slot:default="{ mutate, loading }">
            <v-btn 
              :disabled="!canProceed || loading" 
              color="primary" 
              class="px-15"
              :loading="loading"
              @click="
                mutate({
                  variables: {
                    firstName: firstName,
                    lastName: lastName,
                    penName: penName,
                    id: userId,
                    creatorNewsletterAgreed: newsletter,
                    }
                })
              ">
              {{ !noChanges ? $t('forms.saveAndContinue') : $t('forms.continue') }}
            </v-btn>
          </template>
        </ApolloMutation>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-row>
      <v-col>
          <v-skeleton-loader class="my-3" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import StoryCityTextInput from "@/components/Reusable/StoryCityTextInput";
import { UPDATE_USER_PROFILE } from "@/graphql/UserQueries";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
export default {
  mixins: [hasLoggedInUser],
  components: {
    StoryCityTextInput,
  },
  data() {
    return {
      initialized: false,
      firstName: "",
      lastName: "",
      penName: "",
      newsLetter: false,
    };
  },
  mounted() {
  },
  methods: {
    proceed() {
      this.$router.push({ name: "become-creator-update-username" });
    },
  },
  watch: {
    user: {
      handler: function (newUser) {
        this.firstName = newUser.userProfile.firstName;
        this.lastName = newUser.userProfile.lastName;
        this.penName = newUser.userProfile.penName;
        this.initialized = true
      },
      deep: true,
    },
  },
  computed: {
    canProceed() {
      if (this.firstName && this.lastName) {
        return true;
      }
      return false;
    },
    noChanges() {
      if (
        this.firstName == this.user.userProfile.firstName &&
        this.lastName == this.user.userProfile.lastName &&
        this.penName == this.user.userProfile.penName
      ) {
        return true;
      }
      return false;
    },
    UPDATE_USER_PROFILE() {
      return UPDATE_USER_PROFILE;
    },
    userId() {
      return this.user.userProfile.id;
    }
  }
};
</script>